import { useState, useEffect, useCallback } from "react";
import { getCurrencyAmount } from "./../../../utils/stringUtils";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { Link } from "react-router-dom";

import Table from "../../../components/common/Table";
import Pagination from "../../../components/common/Pagination";
import Toaster from "./../../../components/common/Toaster";

import invoiceService from "./../../../services/invoiceService";
import moment from "moment";

const InvoicesTable = ({ data, columns, options, onChange, setData }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchInvoices = useCallback(
    async (mounted) => {
      try {
        setIsLoading(true);

        const response = await invoiceService.getInvoicesAsync(options);
        const { result, page, total_count } = response;

        const items = result.map((item) => {
          const is_paid = item.is_paid
            ? { title: "Paid", color: "bg-green-400" }
            : { title: "Unpaid", color: "bg-red-400" };

          const classes = `px-1 text-center rounded text-white text-xs w-2/3 ${is_paid.color}`;

          const posted = item.is_posted ? (
            <IoCheckmarkCircleOutline
              className="text-green-500 mr-2"
              title="Posted"
            />
          ) : (
            ""
          );

          item["amount"] = getCurrencyAmount(item.amount);
          item["is_paid"] = <div className={classes}>{is_paid.title}</div>;

          item["period"] = `${moment(item.period_start).format(
            "MMM DD, yyyy"
          )} - ${moment(item.period_end).format("MMM DD, yyyy")}`;

          item["name"] = (
            <Link
              className="hover:text-blue-500"
              to={`/accounts/${item.account_id}`}
            >
              {item.name}
            </Link>
          );

          item["invoice_number"] = (
            <Link
              className="flex items-center hover:text-blue-500"
              to={`/invoice/${item.id}`}
              target="_blank"
            >
              {posted}
              {item.invoice_number}
            </Link>
          );

          return item;
        });

        if (mounted) {
          setData(items);
          setCurrentPage(page);
          setTotalCount(total_count);
          setIsLoading(false);
        }
      } catch (ex) {
        Toaster.Error("Something went wrong.");
        setIsLoading(false);
      }
    },
    [options, setData]
  );

  const handleSort = (sort_column) => {
    const new_options = { ...options };
    new_options.sort_column = sort_column;
    onChange(new_options);
  };

  const handlePageChange = (page) => {
    const new_options = { ...options };
    new_options.current_page = page;
    onChange(new_options);
  };

  useEffect(() => {
    let mounted = true;

    fetchInvoices(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchInvoices]);

  return (
    <div className="mt-10 overflow-auto">
      <Table
        data={data}
        columns={columns}
        sortColumn={options.sort_column}
        onSort={handleSort}
        isLoading={isLoading}
      />
      <Pagination
        itemsCount={totalCount}
        currentPage={currentPage}
        pageSize={options.size}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default InvoicesTable;
